
/*
 * Modules
 */

import './modules/progress-bar.js';
import './modules/button-text.js';
import './modules/animations.js';
import './modules/handle-slider.js';
import './modules/parallax.js';
import './modules/fixed-element.js';
